import React from 'react';
import './Contact.css'
import UilReact from '@iconscout/react-unicons/icons/uil-react'
import { UilLocationArrow } from '@iconscout/react-unicons'
import { UilFacebook } from '@iconscout/react-unicons'
import { UilInstagramAlt } from '@iconscout/react-unicons'
import { UilGithub } from '@iconscout/react-unicons'
import { UilLinkedin } from '@iconscout/react-unicons'
import { UilOutgoingCall } from '@iconscout/react-unicons'
import cv from '../../Asset/my-cv.pdf'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_dcw5mpl', 'template_a7so3h7', form.current, 'UR3_ayiZTVuhDIF8h')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            }
            );
        e.target.reset()
    };
    return (
        <div className='contact'>
            <div className="container">
                <div className="row">
                    <div className="contact-left" data-aos="fade-right" data-aos-duration="2000">
                        <h1 className='sub-title'>Contact Me</h1>
                        <p className='flex'><UilLocationArrow color="#ff114f" /> yeasinarafat54239@gmail.com</p>
                        <p className='flex'><UilOutgoingCall color="#ff114f" /> +880 1770-491801</p>
                        <div className="social-icons">
                            <a href=""><UilFacebook color="#ff114f" /></a>
                            <a href=""><UilInstagramAlt color="#ff114f" /></a>
                            <a href=""><UilGithub color="#ff114f" /></a>
                            <a href=""><UilLinkedin color="#ff114f" /></a>
                        </div>
                        <a href={cv} download className='btn btn-2' >Download CV</a>
                    </div>
                    <div className="contact-right"
                        data-aos="fade-left"
                        data-aos-duration="2000">
                        <form ref={form} onSubmit={sendEmail}>
                            <label>Name</label>
                            <input type="text" name="from_name" placeholder='Your Name' required />
                            <label>Email</label>
                            <input type="email" name="to_name" placeholder='Your Email' required />
                            <label>Message</label>
                            <textarea name="message" rows="6" placeholder='Your Message' required></textarea>
                            <button type='submit' value="Send" className='btn btn-2'>Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;